import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
const services = [{
  title: "Kitchen Renovations",
  description: "Bespoke designs for Victorian and Edwardian homes, merging period charm with high-end modern functionality and luxury finishes."
}, {
  title: "Bi-Fold Installations",
  description: "Premium glazing solutions that seamlessly connect your interior living spaces with the beauty of the garden for an airy feel."
}, {
  title: "Open-Plan Conversions",
  description: "Expert structural transformations creating light-filled, expansive areas tailored for modern London family lifestyles and entertaining."
}, {
  title: "Garden & Bathrooms",
  description: "Luxury wet rooms and garden-facing retreats designed to add significant value and architectural tranquility to your London home."
}, {
  title: "Structural Extensions",
  description: "Meticulously crafted rear and side-return extensions designed to maximize square footage in traditional terraced properties."
}, {
  title: "Design & Planning",
  description: "Comprehensive architectural guidance from the initial vision and mood boards to the final, high-end bespoke finish."
}];
export default function CuratedExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="11095" id="our-specialisations" ref={ref} className="bg-background py-24 sm:py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div className={`max-w-2xl mb-16 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="font-serif text-4xl md:text-5xl text-foreground mb-6">
            Our Specialisations
          </h2>
          <p className="text-muted-foreground text-lg font-sans leading-relaxed max-w-xl">
            BVP Group delivers premium home transformations across London, focusing on light, space, and architectural excellence for discerning homeowners.
          </p>
        </div>

        {}
        <div className={`border border-primary/20 bg-primary/5 grid grid-cols-1 md:grid-cols-3 gap-[1px] transition-all duration-1000 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {services.map((service, i) => <div key={i} data-index={i} className="group bg-background p-8 md:p-12 hover:bg-accent transition-colors duration-500 flex flex-col justify-between min-h-[320px] border-t border-primary/30">
              <div className="flex justify-between items-start mb-8">
                <span className="font-serif text-secondary text-lg tracking-widest">
                  0{i + 1}
                </span>
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500 -translate-x-2 group-hover:translate-x-0">
                  <ArrowRight className="w-5 h-5 text-secondary" />
                </div>
              </div>

              <div>
                <h3 className="font-serif text-2xl text-foreground mb-4 group-hover:text-accent-foreground transition-colors">
                  {service.title}
                </h3>
                <p className="font-sans text-sm text-muted-foreground leading-[1.8] group-hover:text-accent-foreground/80 transition-colors">
                  {service.description}
                </p>
              </div>
            </div>)}
        </div>

        {}
        <div className={`mt-16 text-center transition-all duration-1000 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Button asChild variant="outline" className="rounded-none border-primary/40 hover:bg-primary hover:text-primary-foreground px-8 py-6 text-base font-sans tracking-wide">
            <Link to="/ContactPage">Book Free Consultation</Link>
          </Button>
        </div>
      </div>
    </section>;
}